import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from '@/components/shadcn-ui/sonner';
import { useUIStore } from '@/stores/useUIStore';

function App() {
  const { mobileSidebarOpen } = useUIStore();

  return (
    <div
      className={`App app-class transition-[margin-left] duration-300 ease-in-out md:!ml-0 ${mobileSidebarOpen ? 'ml-[75vw]' : 'ml-0'
        }`}
    >
      <Navbar />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      <Toaster />
    </div>
  );
}

export default App;
